// extracted by mini-css-extract-plugin
export default {"user-not-active":"user-not-active-SbPIg","page-body":"page-body-eBXee"};